import { ReactComponent as Download } from 'assets/icons/icon-download.svg';

export default Download;
